import { render, staticRenderFns } from "./UserHeaderInformation.vue?vue&type=template&id=a9907af6&scoped=true"
import script from "./UserHeaderInformation.vue?vue&type=script&lang=js"
export * from "./UserHeaderInformation.vue?vue&type=script&lang=js"
import style0 from "./UserHeaderInformation.vue?vue&type=style&index=0&id=a9907af6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9907af6",
  null
  
)

export default component.exports